export { default } from './PageEventOrganizer.vue'
